import { Map, Set } from 'immutable'
import { handleActions, combineActions } from 'redux-actions'
import { combineReducers } from 'redux-immutable'
import * as actions from './actions'
import { CsvImport } from './models'

const status = handleActions({
  [combineActions(
    actions.uploadCsv,
    actions.uploadCsvPending,
    actions.uploadCsvFailed,
    actions.uploadCsvCancelled,
    actions.uploadCsvSuccess,
  )]: (state, action) => {
    return state.set('upload', action.type)
  },

  [combineActions(
    actions.startCsvImport,
    actions.startCsvImportPending,
    actions.startCsvImportFailed,
    actions.startCsvImportSuccess,
  )]: (state, action) => {
    return state.set('start', action.type)
  },

  [actions.clearCsv]: () => Map()
}, Map())

const selected = handleActions({
  [actions.setSelected]: (state, action) => {
    return action.payload.filter(attribute => !!attribute).keySeq().toSet()
  },

  [actions.toggleColumn]: (state, action) => {
    const { column } = action.payload
    if (state.has(column)) {
      return state.delete(column)
    } else {
      return state.add(column)
    }
  },

  [actions.clearCsv]: () => Set(),
}, Set())

const data = handleActions({
  [actions.uploadCsv]: (state, action) => {
    return state.set('fileName', action.payload.file.name)
  },

  [actions.uploadCsvSuccess]: (state, action) => {
    return state.set('csvImport', action.payload)
  },

  [actions.setMapping]: (state, action) => {
    return state.setIn(['csvImport', 'attributeMapping'], action.payload)
  },

  [combineActions(
    actions.clearCsv,
    actions.uploadCsvCancelled,
    actions.uploadCsvFailed,
  )]: (state) => {
    return state
      .delete('fileName')
      .set('csvImport', CsvImport())
  },
}, Map())

export default combineReducers({ status, data, selected })



// WEBPACK FOOTER //
// ./src/scripts/app/modules/csv/reducer.js